<template>
  <label
    class="flex items-center gap-spacing_6 pe-spacing_3"
    :class="{ 'flex-row-reverse': rightAligned }"
  >
    <input
      v-model="selectedValue"
      class="hidden"
      type="radio"
      :name
      :value
      :disabled
    />
    <span
      class="flex aspect-square h-[18px] w-[18px] cursor-pointer items-center justify-center rounded-full bg-neutral-50 outline outline-1 outline-offset-[3px] outline-action transition"
      :class="{
        '!bg-action': selectedValue === value,
        '!cursor-not-allowed !bg-neutral-500 !outline-neutral-500':
          selectedValue === value && disabled,
        '!cursor-not-allowed !bg-neutral-50 !outline-neutral-400':
          selectedValue !== value && disabled,
        '!cursor-not-allowed': disabled,
      }"
    />

    <div class="flex grow items-center gap-1">
      <CommonUIcons
        v-if="icon"
        class="h-icon_size_5 w-icon_size_5"
        :name="icon"
      />

      <img
        v-else-if="image"
        alt="radio option image"
        class="w-icon_size_11"
        :src="image"
      />

      <span
        class="line-clamp-1 break-words break-all font-secondary text-neutral-800"
        :class="'text-size_4'"
      >
        <span>{{ label }}</span>
        <span v-if="required" class="text-errors">*</span>
      </span>
    </div>
  </label>
</template>

<script setup lang="ts">
import type { RadioProps } from "~/types/schemas/common/Atom/radio";

const selectedValue = defineModel<string | number>();

withDefaults(defineProps<RadioProps>(), {
  name: "radio",
});
</script>
